// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
async function promiseWithTimeout(timeoutMs, promise, failureMessage) {
    let timeoutHandle;
    const timeoutPromise = new Promise((resolve, reject) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        timeoutHandle = (setTimeout(() => reject(new Error(failureMessage)), timeoutMs));
    });
    return Promise.race([promise, timeoutPromise]).then((result) => {
        clearTimeout(timeoutHandle);
        return result;
    });
}
export default promiseWithTimeout;
//# sourceMappingURL=timeout.js.map